{
  "additional_products": "Additional products",
  "bikes": "Bikes",
  "booking_summary": "Booking summary",
  "cabins": "Cabins",
  "date": "Date",
  "departure": "Departure",
  "local_costs": "Local costs",
  "port_of_departure": "Port of departure",
  "ship": "Ship",
  "tour": "Tour"
}
